import React from 'react';

const IndexServices = () => (
  <section className="pt-7 pb-lg-9 pb-7 overflow-hidden">
    <div className="container">
      <div className="position-relative">
        <div className="position-absolute top left ml-7 mt-8 z-index-9 d-none d-lg-block">
          <img className="svg-injector" src="images/svg/shape-06.svg" alt="svg" />
        </div>

        <div className="row">
          <div className="col-12 text-center mb-lg-6 mb-0 mb-lg-4">
            <div className="mb-md-6 mb-5">
              <h2 className="font-weight-normal mb-2">Our services include</h2>
              <p className="mb-0">Soon there will be 2 kinds of people. Those who use computer, and those who use mobile phone.</p>
              <p className="mb-0">Probably both...</p>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-md-6 mb-5 mb-md-0">
            <div className="border shadow border-radius-lg p-lg-6 p-5 bg-white">
              <span className="badge badge-primary badge-primary-soft position-absolute top right mt-4 mr-6">Computer</span>

              <img src="images/services/computer-mouse.png" alt="web development" />

              <h4 className="font-weight-normal mt-4">Web App Development</h4>
              <p className="mb-0">We build a mobile-friendly web application. It can be hosted on cloud or on client premise.</p>
            </div>
          </div>

          <div className="col-md-6 mb-5 mb-md-0">
            <div className="border shadow border-radius-lg p-lg-6 p-5 bg-white">
              <span className="badge badge-warning-soft position-absolute top right mt-4 mr-6">Mobile Phone</span>

              <img src="images/services/google-mobile.png" alt="application development" />

              <h4 className="font-weight-normal mt-4">Mobile App Development</h4>
              <p className="mb-0">
                We make iOS and Android application using React Native, an open-source mobile application framework created by Facebook.
              </p>
            </div>
          </div>
        </div>

        <div className="position-absolute bottom right mr-n8 mb-n8 z-index-n1 d-none d-xl-block">
          <img className="svg-injector mt-9 mr-n9" src="images/svg/shape.svg" alt="svg" />
          <img className="svg-injector ml-n8" src="images/svg/shape-02.svg" alt="svg" />
        </div>
      </div>
    </div>
  </section>
);

export default IndexServices;
